export default {
  test: function() {
    var arrTimes = [];
    var i = 0; // start
    var timesToTest = 10;
    var tThreshold = 150; //ms
    var testImage = "https://s3.us-west-2.amazonaws.com/ttto-utility-bucket/speed-test-image.gif";
    var dummyImage = new Image();
    var isConnectedFast = false;

    return new Promise(function(resolve, reject) {
      testLatency(function(avg) {
        resolve(parseInt(avg))
      });
    });


    /** test and average time took to download image from server, called recursively timesToTest times */
    function testLatency(cb) {
      var tStart = new Date().getTime();
      if (i < timesToTest - 1) {
        dummyImage.src = testImage + '?t=' + tStart;
        dummyImage.onload = function() {
          var tEnd = new Date().getTime();
          var tTimeTook = tEnd - tStart;
          arrTimes[i] = tTimeTook;
          testLatency(cb);
          i++;
        };
      } else {
        /** calculate average of array items then callback */
        var sum = arrTimes.reduce(function(a, b) { return a + b; });
        var avg = sum / arrTimes.length;
        cb(avg);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/packages/speed-test/index.js